import { createGlobalStyle } from 'styled-components';

import FigtreeLight from './Figtree-Light.ttf';
import FigtreeMedium from './Figtree-Medium.ttf';

export default createGlobalStyle`

  @font-face {
    font-family: 'Figtree';
    src: local('Figtree'), url(${FigtreeLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Figtree';
    src: local('Figtree'), url(${FigtreeMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }`;
